/*
 * @Description:
 * @Author: xyw
 * @Date: 2021-09-09 15:44:20
 * @LastEditTime: 2021-09-09 17:08:17
 * @LastEditors: xyw
 */
import Request from '@/utils/request'
//案件子状态字典
export function childStateDict(params) {
  return Request.get('/caseManage/childStateDict', { params })
}
//版权类型字典
export function corpDict(params) {
  return Request.get('/caseManage/corpDict', { params })
}
//案件管理列表
export function list(data) {
  return Request.post('/caseManage/list', data)
}
// 确认核对表
export function showCheckForm(data) {
  return Request.post('/checkForm/showCheckForm', data)
}

// 核对表有误
export function confirmMistake(data) {
  return Request.post('/checkForm/confirmMistake', data)
}

// 核对表无误
export function confirmNoMistake(data) {
  return Request.post('/checkForm/confirmNoMistake', data)
}

//取消案件
export function cancelCopr(data) {
  return Request.post('/coprRegist/cancelCopr', data)
}
